module.exports = __webpack_public_path__ + "faf0e9cb80df4f41ebcf52b09b88e513.mp4";